import { registerSW } from 'virtual:pwa-register';

export default {
  /** @param {object} _app */
  install(_app) {
    registerSW();
  }
}